import { useCallback } from 'react';
import { useLocalStorage } from 'usehooks-ts';

export const useAudioNotification = () => {
  const [voiceAlerts] = useLocalStorage('voice_alerts_settings', {
    newConversation: true,
    handoff: true,
    newMessageToMe: true,
    newMessage: false,
  });

  const playNotification = useCallback(
    (alertType: keyof typeof voiceAlerts, source: string | undefined) => {
      if (
        (!voiceAlerts[alertType] && source !== 'toggle') ||
        (voiceAlerts[alertType] && source === 'toggle')
      )
        return;

      // Create and play audio notification
      const audio = new Audio(`/static/audio/alerts/${alertType}.mp3`);
      audio.volume = 0.5;
      audio.preload = 'auto';

      audio.play().catch((error) => {
        console.error('Failed to play notification sound:', error);
      });
    },
    [voiceAlerts],
  );

  return { playNotification };
};
